import { render, staticRenderFns } from "./FirebaseLogin.vue?vue&type=template&id=e639873c"
import script from "./FirebaseLogin.vue?vue&type=script&lang=js"
export * from "./FirebaseLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports